export default "__VITE_ASSET__CKDFsp09__"